import React from 'react';
import { MimaText, NewModal, PageLoader, Pagination } from '../../components';
import useViewSubscriptionTx from './logic/useViewSubscriptionTx';
import styles from '../../assets/styles/PlansBilling/PlansBilling.module.scss';
import { amountFormatter } from '../../utils/utils';
import moment from 'moment';

const ViewSubscriptionTx = ({ closeModal, customerId }) => {
	const {
		isLoading,
		isFetching,
		subTransactions,
		subscriptionTotalCounts,
		currentPage,
		setCurrentPage,
	} = useViewSubscriptionTx({ customerId });
	return (
		<NewModal closeModal={closeModal}>
			{isLoading ? (
				<PageLoader loading={isLoading} title="while we fetch your data" />
			) : (
				<>
					<MimaText variant="subtitleBold" align="center" mb={2}>
						Subscription Payments
					</MimaText>

					<div className={styles.txs}>
						{subTransactions?.map((x, i) => (
							<div key={i} className={styles.tx}>
								<div className={styles.tx__flex}>
									<MimaText variant="bodyBold">
										{x?.customer?.fullname}
									</MimaText>
									<MimaText variant="bodyBold">
										{amountFormatter(x?.currencyCode).format(x?.amountPaid)}
									</MimaText>
								</div>
								<div className={styles.tx__flex}>
									<MimaText variant="small">
										{moment(x?.createdAt).format('Do MMM YYYY')}
									</MimaText>
								</div>
							</div>
						))}
						{isFetching && <PageLoader loading={isFetching} type="bar" />}
						<Pagination
							// onLimitChange={onLimitChange}
							currentPage={currentPage}
							totalItems={subscriptionTotalCounts}
							setCurrentPage={setCurrentPage}
						/>
					</div>
				</>
			)}
		</NewModal>
	);
};

export default ViewSubscriptionTx;
